import React, { MouseEvent, useEffect, useRef } from 'react';
interface FollowCursorButtonProps {
  label: string;
  href: string;
}
const TWO_PI = Math.PI * 2;

// Faithful port of the original footer script (is-followcursor-element):
// - the label is static (no text roll in the original markup)
// - while the mouse moves over the button, the arrow eases toward the cursor (lerp 0.1 per frame, shortest path)
// - on leave the arrow keeps its last direction — the original never resets it
function lerpAngle(from: number, to: number, t: number) {
  const diff = ((to - from + Math.PI) % TWO_PI + TWO_PI) % TWO_PI - Math.PI;
  return from + diff * t;
}
export function FollowCursorButton({
  label,
  href
}: FollowCursorButtonProps) {
  const arrowRef = useRef<HTMLSpanElement>(null);
  const state = useRef({
    current: 0,
    target: 0,
    raf: 0
  });
  useEffect(() => () => cancelAnimationFrame(state.current.raf), []);
  const tick = () => {
    const s = state.current;
    s.current = lerpAngle(s.current, s.target, 0.1);
    if (arrowRef.current) arrowRef.current.style.transform = `rotate(${s.current}rad)`;
    const remaining = Math.abs(lerpAngle(s.current, s.target, 1) - s.current);
    s.raf = remaining > 0.0005 ? requestAnimationFrame(tick) : 0;
  };
  const handleMove = (e: MouseEvent<HTMLAnchorElement>) => {
    if (!arrowRef.current) return;
    const rect = arrowRef.current.getBoundingClientRect();
    state.current.target = Math.atan2(e.clientY - (rect.top + rect.height / 2), e.clientX - (rect.left + rect.width / 2));
    if (!state.current.raf) state.current.raf = requestAnimationFrame(tick);
  };
  return <a href={href} onMouseMove={handleMove} className="relative flex h-[65px] items-center gap-[1.8125rem] overflow-hidden rounded-[1rem] bg-black pl-[1.875rem] pr-3 sm:h-[5.31rem] md:rounded-[1.25rem] md:pr-[0.875rem]" data-id="element-88" data-mp="3fvj21i5jgm2d">
      <span className="relative text-[1.125rem] font-normal leading-[1.1] tracking-[0.01em] text-white sm:text-[1.5625rem]" data-id="element-89" data-mp="2n6u5zxjcb6xh">
        {label}
      </span>
      <span className="relative flex h-[46px] w-[46px] items-center justify-center overflow-hidden rounded-[0.9375rem] bg-white sm:h-14 sm:w-14" data-id="element-90" data-mp="2k58wkj1lgku1">
        <span ref={arrowRef} className="flex h-6 w-6 text-black" data-id="element-91" data-mp="2g3x5sa6zhtk9">
          <svg viewBox="0 0 20 20" fill="none" className="h-full w-full" aria-hidden="true" data-id="element-92" data-mp="2tuiq83c36bk9">
            <path d="M10.4688 4.375L16.0937 10L10.4688 15.625M15.3125 10L3.90626 10" stroke="currentColor" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1.875" data-id="element-93" data-mp="2ow7hjvxj273m" />
          </svg>
        </span>
      </span>
    </a>;
}